<div class="container">
  @if (permissions !== null && permissions._edit) {
    <fund-page-buttons
      (addFund)="addFundDialog()"
      (addCertificated)="addOutletDialog()"
      [barType]="FundBtnType.LIST"
    ></fund-page-buttons>
  }
  <!--  <div class="row button-row">-->
  <!--    <div class="col-3">-->
  <!--      <button mat-raised-button class="add-btn mat-elevation-z2" (click)="addFundDialog()"><i class="material-icons" style="font-size: 16px">add</i><i class="material-icons" style="font-size: 16px; margin-right: 3px">account_balance</i>Fund</button>-->
  <!--      <button mat-raised-button class="add-btn mat-elevation-z2" (click)="addOutletDialog()"><i class="material-icons" style="font-size: 16px">add</i><i class="material-icons" style="font-size: 16px; margin-right: 3px">account_balance</i>Certificated</button>-->
<!--    </div>-->
<!--  </div>-->
<div class="table-header">
  <mat-paginator
    [length]="total"
  [pageSize]="perPage"></mat-paginator>
  <!--    <mat-paginator-->
  <!--    [pageSize]="50"-->
  <!--    [pageIndex]="currentPage"-->
  <!--    [length]="dataSource ? dataSource.data.length : 0"-->
  <!--    (page)="getPage($event)"-->
<!--    ></mat-paginator>-->
<div class="row" style="justify-content: flex-end; font-size: 12px; margin-bottom: 5px;">
  Jump To Page:&nbsp;&nbsp;&nbsp;@for (page of pages; track page) {
  <a href="" class="page-link" [ngClass]="{'selected' : isSelectedPage(page)}" (click)="$event.preventDefault(); goToPage(page)">{{page.pageIndex  + 1}}</a>
}
</div>
</div>
<div class="table-section">
  <table mat-table [dataSource]="dataSource" matSort class="stripped-table mat-elevation-z2" (matSortChange)="pageSort($event)">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>n
      <td mat-cell *matCellDef="let fund"><a href="{{dataFormat.formatLink(fund)}}" class="fund-link" target = '_blank'><strong>{{fund.name}}</strong></a></td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let fund">{{fund.type}}</td>
    </ng-container>
    <ng-container matColumnDef="srSyndications">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Sr. Syndications Analyst</th>
      <td mat-cell *matCellDef="let fund">
        @if (fund.srSyndications.length==0) {
          <div>--</div>
        }
        @if (fund.srSyndications.length>0) {
          @for (participant of fund.srSyndications; track participant; let last = $last) {
            <a href="{{dataFormat.formatLink(participant.person)}}" class="fund-link" target="_blank">{{participant.person.name}}</a>{{!last ? ", " : ""}}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="syndications">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Syndications Analyst</th>
      <td mat-cell *matCellDef="let fund">
        @if (fund.syndications.length==0) {
          <div>--</div>
        }
        @if (fund.syndications.length>0) {
          @for (participant of fund.syndications; track participant; let last = $last) {
            <a href="{{dataFormat.formatLink(participant.person)}}" class="fund-link" target="_blank">{{participant.person.name}}</a>{{!last ? ", " : ""}}
          }
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="accMgr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Manager</th>
      <td mat-cell *matCellDef="let fund">
        @if (fund.accMgr.length==0) {
          <div>--</div>
        }
        @if (fund.accMgr.length>0) {
          @for (participant of fund.accMgr; track participant; let last = $last) {
            <a href="{{dataFormat.formatLink(participant.person)}}" class="fund-link" target="_blank">{{participant.person.name}}</a>{{!last ? ", " : ""}}
          }
        }</td>
      </ng-container>
      <ng-container matColumnDef="closeDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Closing Date</th>
        <td mat-cell *matCellDef="let fund">{{fund.closeDate | date: 'MM/dd/yyyy'}}</td>
      </ng-container>
      <ng-container matColumnDef="totalCommitted">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Committed Equity</th>
        <td mat-cell *matCellDef="let fund">
          @if (fund.totalCommitted==null) {
            --
          }
          @if (fund.totalCommitted!==null) {
            {{fund.totalCommitted | currency: 'USD': 'symbol':'1.0-0'}}
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="totalSpecified">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Specified Equity</th>
        <td mat-cell *matCellDef="let fund">
          @if (fund.totalSpecified===null || fund.totalSpecified===0) {
            --
          }
          @if (fund.totalSpecified!==null && fund.totalSpecified>0) {
            {{fund.totalSpecified | currency: 'USD': 'symbol': '1.0-0'}}
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let fund; columns: columns;"></tr>
    </table>
  </div>
</div>
